/* afx-product-layout.js v2 — Product page layout & conversion enhancements
 * 1. Moves buy-buttons section above the product description
 * 2. Converts long description into a 3-tab interface
 * 3. Adds a sticky Add-to-Cart bar when the main button scrolls out of view
 * 4. Dynamic price calculator (qty x price = total)
 * 5. Trust badges below buy buttons
 */
(function() {
  'use strict';

  if (window.__afxProductLayoutInit) return;
  window.__afxProductLayoutInit = true;

  var mainSection = document.querySelector('[data-section-type="static-product"]');
  if (!mainSection) return;

  /* ================================================================
     STYLES
     ================================================================ */
  var css = [
    /* --- Tabs --- */
    '.afx-tabs-nav{display:flex;gap:0;border-bottom:2px solid #e2e2e2;margin:28px 0 20px;overflow-x:auto;-webkit-overflow-scrolling:touch}',
    '.afx-tab-btn{padding:11px 22px;border:none;background:none;font-size:14px;font-weight:600;color:#888;cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-2px;transition:color .2s,border-color .2s;white-space:nowrap;letter-spacing:.02em}',
    '.afx-tab-btn:hover{color:#444}',
    '.afx-tab-btn.afx-active{color:#1a1a1a;border-bottom-color:#1a1a1a}',
    '.afx-tab-panel{display:none;animation:afxFadeIn .25s ease}',
    '.afx-tab-panel.afx-active{display:block}',
    '@keyframes afxFadeIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}',

    /* --- Hide duplicate MOQ badge (keep in DOM for afx-moq.js) --- */
    '.afx-moq-badge{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;border:0!important;padding:0!important;margin:0!important}',

    /* --- Sticky Add-to-Cart bar --- */
    '.afx-sticky-bar{position:fixed;bottom:0;left:0;right:0;background:#fff;border-top:1px solid #ddd;box-shadow:0 -2px 12px rgba(0,0,0,.1);padding:10px 20px;display:flex;align-items:center;justify-content:center;gap:16px;z-index:9999;transform:translateY(100%);transition:transform .3s ease}',
    '.afx-sticky-bar.afx-visible{transform:translateY(0)}',
    '.afx-sticky-bar__info{flex:1;min-width:0;max-width:420px}',
    '.afx-sticky-bar__title{font-size:13px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#1a1a1a;line-height:1.3}',
    '.afx-sticky-bar__price{font-size:15px;font-weight:700;color:#1a1a1a}',
    '.afx-sticky-bar__price .afx-was{font-size:12px;color:#999;text-decoration:line-through;margin-right:6px;font-weight:400}',
    '.afx-sticky-bar__btn{background:#1a1a1a;color:#fff;border:none;padding:12px 32px;font-size:14px;font-weight:600;border-radius:4px;cursor:pointer;white-space:nowrap;flex-shrink:0;transition:background .15s}',
    '.afx-sticky-bar__btn:hover{background:#333}',

    /* --- Reorder visual separator --- */
    '.afx-buy-moved{padding-top:4px}',

    /* --- Dynamic price calculator --- */
    '.afx-price-calc{font-size:13px;color:#555;margin:8px 0 4px;line-height:1.5;transition:opacity .2s}',
    '.afx-price-calc__total{font-weight:700;color:#1a1a1a;font-size:16px}',
    '.afx-price-calc__savings{color:#28a745;font-size:12px;margin-left:6px;font-weight:500}',

    /* --- Trust badges --- */
    '.afx-trust-badges{display:flex;flex-wrap:wrap;gap:14px 20px;margin:16px 0 8px;padding:14px 0 0;border-top:1px solid #eee}',
    '.afx-trust-badge{display:flex;align-items:center;gap:7px;font-size:12px;color:#555;font-weight:500;line-height:1.3}',
    '.afx-trust-badge svg{flex-shrink:0;width:18px;height:18px}',
    '.afx-trust-badge--green svg{color:#28a745}',
    '.afx-trust-badge--blue svg{color:#0066cc}',
    '.afx-trust-badge--gold svg{color:#d4a017}',

    /* --- Mobile --- */
    '@media(max-width:768px){',
    '  .afx-tab-btn{padding:9px 14px;font-size:13px}',
    '  .afx-sticky-bar{padding:8px 12px;gap:10px}',
    '  .afx-sticky-bar__btn{padding:11px 22px;font-size:13px}',
    '  .afx-sticky-bar__title{font-size:12px}',
    '  .afx-trust-badges{gap:10px 16px}',
    '  .afx-trust-badge{font-size:11px}',
    '  .afx-trust-badge svg{width:16px;height:16px}',
    '  .afx-price-calc__total{font-size:15px}',
    '}'
  ].join('\n');

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  /* ================================================================
     1. REORDER: Move buy section above description
     ================================================================ */
  function reorderBlocks() {
    /* Find the description container — the parent of our generated content */
    var descMarker = document.querySelector('.afx-lead') ||
                     document.querySelector('.afx-features') ||
                     document.querySelector('.afx-specs');
    if (!descMarker) return;

    /* Walk up to find the "block" wrapper.
       Empire themes wrap each section in a .product-block or similar div. */
    var descBlock = descMarker.closest(
      '.product-block, .product-block--description, [data-product-block], .rte'
    );
    if (!descBlock) descBlock = descMarker.parentElement;
    if (!descBlock) return;

    /* Find the buy form */
    var buyForm = mainSection.querySelector(
      'form[action*="/cart/add"], form[action*="/cart"]'
    );
    if (!buyForm) return;

    /* The form might be inside a wrapper block */
    var buyBlock = buyForm.closest(
      '.product-block, .product-block--buy-buttons, [data-product-block]'
    );
    if (!buyBlock || buyBlock.contains(descBlock)) buyBlock = buyForm;

    /* Also grab the Shop Pay / dynamic checkout buttons if they're a sibling */
    var shopPay = buyBlock.nextElementSibling;
    var moveShopPay = shopPay && (
      shopPay.querySelector('[data-shopify="payment-button"]') ||
      shopPay.querySelector('.shopify-payment-button') ||
      shopPay.classList.contains('product-block--buy-buttons')
    );

    /* Only reorder if description currently appears BEFORE buy section */
    if (descBlock.compareDocumentPosition(buyBlock) & Node.DOCUMENT_POSITION_FOLLOWING) {
      buyBlock.classList.add('afx-buy-moved');
      descBlock.parentElement.insertBefore(buyBlock, descBlock);
      if (moveShopPay && shopPay) {
        descBlock.parentElement.insertBefore(shopPay, descBlock);
      }
    }

    /* Also move the share/social block that was between buy and desc */
    var shareBlock = mainSection.querySelector(
      '.product-block--share, .share-buttons, [class*="share"]'
    );
    if (shareBlock && descBlock.compareDocumentPosition(shareBlock) & Node.DOCUMENT_POSITION_FOLLOWING) {
      /* Leave share where it is — below description is fine */
    }
  }

  /* ================================================================
     2. TABBED DESCRIPTION
     ================================================================ */
  function createTabs() {
    /* Find the actual content container directly.
       The Empire theme wraps description in .product-block > .rte > .afx-product.
       We need .afx-product (the inner div with all the h2-delimited sections). */
    var descContainer = document.querySelector('.afx-product');
    if (!descContainer) {
      var lead = document.querySelector('.afx-lead');
      if (!lead) return;
      descContainer = lead.parentElement;
    }
    if (!descContainer) return;

    var children = Array.from(descContainer.children);
    if (children.length < 4) return; /* Not enough to justify tabs */

    /* Split children into sections delimited by H2 */
    var sections = [];
    var cur = { heading: '', headingEl: null, elements: [] };

    children.forEach(function(el) {
      if (el.tagName === 'H2') {
        if (cur.elements.length > 0 || cur.heading) sections.push(cur);
        cur = { heading: el.textContent.trim(), headingEl: el, elements: [] };
      } else {
        cur.elements.push(el);
      }
    });
    if (cur.elements.length > 0) sections.push(cur);
    if (sections.length < 2) return;

    /* Group sections into 3 tabs */
    var tabDefs = [
      { id: 'overview',  label: 'Overview',        test: /why.*pro|choose|feature|why.*buy|trust/i },
      { id: 'specs',     label: 'Specifications',  test: /spec/i },
      { id: 'more',      label: 'More Info',       test: /about|faq|frequently|document|safety/i }
    ];

    var tabContents = { overview: [], specs: [], more: [] };

    sections.forEach(function(sec) {
      var matched = false;
      for (var t = 0; t < tabDefs.length; t++) {
        if (tabDefs[t].test.test(sec.heading)) {
          tabContents[tabDefs[t].id].push(sec);
          matched = true;
          break;
        }
      }
      if (!matched) {
        /* No heading match — intro content goes to overview */
        tabContents.overview.unshift(sec);
      }
    });

    /* Build only tabs that have content */
    var activeTabs = tabDefs.filter(function(td) {
      return tabContents[td.id].length > 0;
    });
    if (activeTabs.length < 2) return;

    /* Create tab nav */
    var nav = document.createElement('div');
    nav.className = 'afx-tabs-nav';
    nav.setAttribute('role', 'tablist');

    activeTabs.forEach(function(tab, i) {
      var btn = document.createElement('button');
      btn.className = 'afx-tab-btn' + (i === 0 ? ' afx-active' : '');
      btn.textContent = tab.label;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('data-tab', tab.id);
      btn.addEventListener('click', function() {
        nav.querySelectorAll('.afx-tab-btn').forEach(function(b) { b.classList.remove('afx-active'); });
        descContainer.querySelectorAll('.afx-tab-panel').forEach(function(p) { p.classList.remove('afx-active'); });
        btn.classList.add('afx-active');
        var panel = descContainer.querySelector('[data-panel="' + tab.id + '"]');
        if (panel) panel.classList.add('afx-active');
      });
      nav.appendChild(btn);
    });

    /* Create panels */
    var panels = activeTabs.map(function(tab, i) {
      var panel = document.createElement('div');
      panel.className = 'afx-tab-panel' + (i === 0 ? ' afx-active' : '');
      panel.setAttribute('data-panel', tab.id);
      panel.setAttribute('role', 'tabpanel');

      tabContents[tab.id].forEach(function(sec) {
        /* Add the heading back, but skip if it matches the tab label exactly */
        if (sec.headingEl) {
          var h = sec.heading.toLowerCase().replace(/[^a-z]/g, '');
          var l = tab.label.toLowerCase().replace(/[^a-z]/g, '');
          if (h !== l) {
            panel.appendChild(sec.headingEl);
          }
        }
        sec.elements.forEach(function(el) { panel.appendChild(el); });
      });

      return panel;
    });

    /* Replace description content */
    descContainer.innerHTML = '';
    descContainer.appendChild(nav);
    panels.forEach(function(p) { descContainer.appendChild(p); });
  }

  /* ================================================================
     3. STICKY ADD-TO-CART BAR
     ================================================================ */
  function createStickyBar() {
    var addBtn = mainSection.querySelector(
      '.add-to-cart-button, [data-add-to-cart], button[name="add"]'
    );
    if (!addBtn) return;

    /* Gather product info */
    var titleEl = mainSection.querySelector('h1, .product-title');
    var salePrice = mainSection.querySelector(
      '.product-price--sale .product-price__amount, .sale-price, .current-price, .price--sale'
    );
    var regPrice = mainSection.querySelector(
      '.product-price--compare .product-price__amount, .compare-price, .original-price, .price--regular'
    );
    if (!salePrice) salePrice = mainSection.querySelector('.product-price__amount, [data-product-price]');

    var title = titleEl ? titleEl.textContent.trim() : 'Product';
    var priceHtml = '';
    if (regPrice && salePrice) {
      priceHtml = '<span class="afx-was">' + regPrice.textContent.trim() + '</span>' +
                  salePrice.textContent.trim();
    } else if (salePrice) {
      priceHtml = salePrice.textContent.trim();
    }

    /* Build bar */
    var bar = document.createElement('div');
    bar.className = 'afx-sticky-bar';
    bar.innerHTML =
      '<div class="afx-sticky-bar__info">' +
        '<div class="afx-sticky-bar__title">' + escHtml(title) + '</div>' +
        '<div class="afx-sticky-bar__price">' + priceHtml + '</div>' +
      '</div>' +
      '<button class="afx-sticky-bar__btn" type="button">Add to Cart</button>';

    document.body.appendChild(bar);

    /* Click: scroll to buy form smoothly */
    bar.querySelector('.afx-sticky-bar__btn').addEventListener('click', function() {
      var form = mainSection.querySelector('form[action*="/cart"]');
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        /* Flash the real button */
        setTimeout(function() {
          var realBtn = form.querySelector('.add-to-cart-button, [data-add-to-cart], button[name="add"]');
          if (realBtn) {
            realBtn.style.transition = 'box-shadow .2s';
            realBtn.style.boxShadow = '0 0 0 3px rgba(26,26,26,.3)';
            setTimeout(function() { realBtn.style.boxShadow = ''; }, 1200);
          }
        }, 600);
      }
    });

    /* Show/hide with IntersectionObserver */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          bar.classList.toggle('afx-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(addBtn);
    } else {
      /* Fallback: show bar when scrolled past button */
      window.addEventListener('scroll', function() {
        var rect = addBtn.getBoundingClientRect();
        bar.classList.toggle('afx-visible', rect.bottom < 0);
      });
    }
  }

  /* ================================================================
     4. DYNAMIC PRICE CALCULATOR
     ================================================================ */
  function createPriceCalculator() {
    /* Get unit price from the product JSON data (reliable, same as afx-moq.js) */
    var dataEl = document.querySelector('[data-section-type="static-product"][data-section-data]');
    var unitPrice = 0;
    if (dataEl) {
      try {
        var sd = JSON.parse(dataEl.textContent);
        if (sd && sd.product) {
          /* Shopify stores prices in cents */
          unitPrice = (sd.product.price || 0) / 100;
        }
      } catch(e) {}
    }
    /* Fallback: parse from any visible price element */
    if (!unitPrice) {
      var allEls = mainSection.querySelectorAll('*');
      for (var i = 0; i < allEls.length; i++) {
        var txt = allEls[i].textContent.trim();
        if (/^\$\d+\.\d{2}$/.test(txt) && allEls[i].children.length === 0) {
          unitPrice = parseFloat(txt.replace('$', ''));
          if (unitPrice > 0) break;
        }
      }
    }
    if (!unitPrice || unitPrice <= 0) return;

    /* Find the quantity input */
    var input = document.querySelector(
      'quantity-selector input, input[name="quantity"], ' +
      '.element-quantity-selector__input, [data-quantity-input]'
    );
    if (!input) return;

    /* Create the calculator display */
    var calc = document.createElement('div');
    calc.className = 'afx-price-calc';

    /* Insert after the form's buy-buttons area.
       Try multiple insertion strategies for Empire theme. */
    var form = input.closest('form');
    var inserted = false;

    if (form) {
      /* Strategy 1: after the quantity selector's parent row */
      var qs = input.closest('quantity-selector');
      var row = qs ? qs.parentElement : null;
      if (row && row.parentElement) {
        row.parentElement.insertBefore(calc, row.nextSibling);
        inserted = true;
      }
      /* Strategy 2: append to the form itself */
      if (!inserted) {
        form.appendChild(calc);
        inserted = true;
      }
    }
    if (!inserted) return;

    function update() {
      var qty = parseInt(input.value, 10) || 1;
      if (qty < 1) qty = 1;
      var total = (qty * unitPrice).toFixed(2);
      calc.innerHTML = qty + ' &times; $' + unitPrice.toFixed(2) +
        ' = <span class="afx-price-calc__total">$' + total + '</span>';
    }

    update();

    /* Listen for all value changes */
    input.addEventListener('input', update);
    input.addEventListener('change', update);

    /* Catch +/- button clicks */
    var qsEl = input.closest('quantity-selector');
    if (qsEl) {
      qsEl.addEventListener('click', function() {
        setTimeout(update, 60);
        setTimeout(update, 250);
      });
    }

    /* Poll for programmatic value changes (afx-moq.js snap corrections) */
    var lastVal = input.value;
    setInterval(function() {
      if (input.value !== lastVal) {
        lastVal = input.value;
        update();
      }
    }, 300);
  }

  /* ================================================================
     5. TRUST BADGES
     ================================================================ */
  function createTrustBadges() {
    /* Find the buy form */
    var form = document.querySelector('form[action*="/cart/add"], form[action*="/cart"]');
    if (!form) return;

    var badges = document.createElement('div');
    badges.className = 'afx-trust-badges';
    badges.innerHTML =
      '<div class="afx-trust-badge afx-trust-badge--green">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>' +
          '<path d="M9 12l2 2 4-4"/>' +
        '</svg>' +
        '<span>Authorized<br>Distributor</span>' +
      '</div>' +
      '<div class="afx-trust-badge afx-trust-badge--blue">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<rect x="1" y="3" width="15" height="13"/>' +
          '<polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>' +
          '<circle cx="5.5" cy="18.5" r="2.5"/>' +
          '<circle cx="18.5" cy="18.5" r="2.5"/>' +
        '</svg>' +
        '<span>Fast US<br>Shipping</span>' +
      '</div>' +
      '<div class="afx-trust-badge afx-trust-badge--green">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>' +
          '<path d="M7 11V7a5 5 0 0110 0v4"/>' +
        '</svg>' +
        '<span>Secure<br>Checkout</span>' +
      '</div>' +
      '<div class="afx-trust-badge afx-trust-badge--gold">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<polyline points="1 4 1 10 7 10"/>' +
          '<path d="M3.51 15a9 9 0 105.64-12.36L1 10"/>' +
        '</svg>' +
        '<span>30-Day<br>Returns</span>' +
      '</div>';

    /* Insert right after the form element */
    if (form.parentElement) {
      form.parentElement.insertBefore(badges, form.nextSibling);
    }
  }

  /* ================================================================
     HELPERS
     ================================================================ */
  function escHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /* ================================================================
     INIT
     ================================================================ */
  function init() {
    var fns = [reorderBlocks, createTabs, createStickyBar, createPriceCalculator, createTrustBadges];
    fns.forEach(function(fn) {
      try { fn(); } catch(e) { console.warn('afx-layout: ' + fn.name + ' failed:', e.message); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
